/* eslint-disable no-console */
import Dexie from "dexie"

const DB_ACC = localStorage.getItem("activeAcc");
const db = new Dexie(`duotalkDB_${DB_ACC}`);
export default class DuoalkIndexedDB {
    ACC = localStorage.getItem("activeAcc");
    VERSION = 1;
    DEBUG = false;
    IS_INITILIZED = false;

    COLLECTIONS = {
        inboxUnsendedMessages: `inboxUnsendedMessages`,
        inboxConversations: `inboxConversations`,
        inboxOperator: `inboxOperator`,
    };

    async init(acc) {
        if (this.DEBUG) console.log("[DuoalkIndexedDB] init", "acc", acc, 'IS_INITILIZED', this.IS_INITILIZED);
        if (acc && !this.IS_INITILIZED) {
            this.IS_INITILIZED = true;
            this.ACC = acc;
            if (this.DEBUG) console.log("[DuoalkIndexedDB] has account");
            db.version(this.VERSION).stores({
                [this.COLLECTIONS.inboxUnsendedMessages]: "++id,messages",
                [this.COLLECTIONS.inboxConversations]: "++id,contactSessionID,*acc,chatID,sessionID,*id,created,updated,*contactID,origin,type,phase,*name,*phone,*email,facebookId,instagramId,whatsappWAID,pendingResponse,profilePic,operator,url,status,online,*intentions,*entities,tags,channel,inAttendance,closed,visible,closingReason,wppApiOn24hWindow,*timestamp,postponedTo",
                [this.COLLECTIONS.inboxOperator]: "++_id,acc,acl,createdAt,updatedAt,entities,intentions,online,status,user"
            });
        }
    }

    constructor() {
        if (this.DEBUG) console.log("[DuoalkIndexedDB] constructor");
        if (this.ACC && !this.IS_INITILIZED) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] has account");
            this.init(this.ACC);
        }
    }

    isInitialized() {
        return this.IS_INITILIZED;
    }

    // #OPERATOR
    async findOperator(id) {
        try {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findOperator", id);
            const docs = await db[this.COLLECTIONS.inboxOperator].where("_id").equals(id).toArray();
            if (docs)
                if (this.DEBUG) {
                    if (docs.length)
                        console.log("[DuoalkIndexedDB] operator founded", docs);
                    else
                        console.log("[DuoalkIndexedDB] operator NOT founded");
                }
            if (docs.length) return docs[0];
            return null;
        } catch (error) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findOperator catch");
            if (error && error.name && error.name === "NotFoundError") return null;
        }
    }

    async createOrUpdateOperator(id, data) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] createOrUpdateOperator", id, data);
        if (await this.findOperator(id)) await db[this.COLLECTIONS.inboxOperator].update(id, data);
        else await db[this.COLLECTIONS.inboxOperator].add(data);
    }

    async deleteOperator(id) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] deleteOperator", id);
        await db[this.COLLECTIONS.inboxOperator].where("_id").equals(id).delete();
    }

    // #CONVERSATIONS
    async countConversations(by = "all", value = null) {
        try {
            if (!db.isOpen()) await db.open()
            if (this.DEBUG) console.log("[DuoalkIndexedDB] countConversations", by, value);
            if (db[this.COLLECTIONS.inboxConversations]) {
                switch (by) {
                    case "intention":
                        {
                            console.log("aa", await db[this.COLLECTIONS.inboxConversations].where("intentions").anyOf(value).and(conversation => conversation.acc === this.ACC).count())
                            return await db[this.COLLECTIONS.inboxConversations].where("intentions").anyOf(value).and(conversation => conversation.acc === this.ACC).count();
                        }
                    default:
                        {
                            const count = await db[this.COLLECTIONS.inboxConversations].count();
                            if (this.DEBUG) console.log("[DuoalkIndexedDB] countConversations DEFAULT", this.ACC, count)

                            return count;
                        }
                }
            }
            return 0;
        } catch (error) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] countConversations catch", error);
            if (error && error.name && error.name === "NotFoundError") return 0;
        }
    }

    async findConversations() {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] findConversations");
        try {
            const conversations = await db[this.COLLECTIONS.inboxConversations].orderBy("timestamp").reverse().toArray();
            if (conversations) return conversations;
            console.log("Found nothing")
            return [];
        } catch (error) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findConversations catch", error);
            return [];
        }
    }

    async findFirstConversation() {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] findFirstConversation");
        try {
            const conversation = await db[this.COLLECTIONS.inboxConversations].first();
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findFirstConversation founded", conversation);
            if (conversation) return conversation;
            return null;
        } catch (error) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findFirstConversation catch", error);
            if (error && error.name && error.name === "NotFoundError") return null;
        }
    }

    async findLastConversation() {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] findLastConversation");
        try {
            const conversation = await db[this.COLLECTIONS.inboxConversations].last();
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findLastConversation founded", conversation);
            if (conversation) return conversation;
            return null;
        } catch (error) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] findLastConversation catch", error);
            if (error && error.name && error.name === "NotFoundError") return null;
        }
    }

    async createManyConversations(conversations) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] createManyConversations");
        if (conversations.length) await db[this.COLLECTIONS.inboxConversations].bulkAdd(conversations);
    }

    async findOneConversation(id = null, contactID = null) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] findOneConversation", id, contactID);
        let docs = []
        if (id && contactID) docs = await db[this.COLLECTIONS.inboxConversations].where("id").equals(id).or("contactID").equals(contactID).toArray();
        else if (id) docs = await db[this.COLLECTIONS.inboxConversations].where("id").equals(id).toArray();
        else docs = await db[this.COLLECTIONS.inboxConversations].where("contactID").equals(contactID).toArray();
        if (docs.length) return docs[0];
        return null;
    }

    async createOrUpdateOneConversation(id, conversation) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] createOrUpdateOneConversation");
        if (await this.findOneConversation(id)) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] update", id, conversation);
            await db[this.COLLECTIONS.inboxConversations].update(id, conversation);
        }
        else {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] add", id, conversation);
            if (Object.keys(conversation).length > 5)
                await db[this.COLLECTIONS.inboxConversations].add(conversation);
        }
    }

    async updateOneConversation(id, conversation) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] updateOneConversation");
        const dbConversation = await this.findOneConversation(id)
        if (dbConversation) {
            if (this.DEBUG) console.log("[DuoalkIndexedDB] update", id, conversation);
            await db[this.COLLECTIONS.inboxConversations].update(id, { ...dbConversation, ...conversation });
        }
    }

    async bulkConversations(bulk) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] bulkConversations");
        await db[this.COLLECTIONS.inboxConversations].bulkPut(bulk);
    }

    async deleteOneConversation(id) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] deleteOneConversation", id);
        await db[this.COLLECTIONS.inboxConversations].delete(id);
    }

    async deleteConversations() {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] deleteConversations");
        if (db[this.COLLECTIONS.inboxConversations])
            await db[this.COLLECTIONS.inboxConversations].clear();
    }

    // #UNSENDED MESSAGES
    async findUnsendedMessage(id) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] findUnsendedMessage", id);
        const docs = await db[this.COLLECTIONS.inboxUnsendedMessages].where("id").equals(id).toArray();
        if (docs.length) return docs[0];
        return null;
    }

    async createOrUpdateUnsendedMessage(id, messages) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] createOrUpdateUnsendedMessage", id, messages);
        if (await this.findUnsendedMessage(id)) await db[this.COLLECTIONS.inboxUnsendedMessages].update(id, { messages });
        else await db[this.COLLECTIONS.inboxUnsendedMessages].add({ id, messages });
    }

    async deleteUnsendedMessage(id) {
        if (!db.isOpen()) await db.open()
        if (this.DEBUG) console.log("[DuoalkIndexedDB] deleteUnsendedMessage", id);
        await db[this.COLLECTIONS.inboxUnsendedMessages].delete(id);
    }

    async deleteDB() {
        await db.delete();
    }

} 